/* @flow */
import gql from 'graphql-tag';
import React from 'react';
import {FormattedMessage, FormattedNumber} from 'react-intl';
import IconButton from '../IconButton/IconButton';

export const fragments = {
    searchBanner: gql`
        fragment PercentBookedSearchBanner on SearchBanner {
            location
            percentageLeft
        }
    `
};

type Props = {
    percentageLeft: number,
    location?: string
};

const searchBannerExplanation = ({percentageLeft, location}: Props) => {
    const linguaValues = {
        percentage: (
            <span className="SearchBanner__accent">
                <FormattedNumber
                    value={percentageLeft / 100}
                    style="percent"
                    maximumSignificantDigits={2}
                />
            </span>
        ),
        location
    };
    if (location) {
        return (
            <FormattedMessage
                id="percentBookedExplanationSpecificLocationInversed"
                description="percent booked specific explanation"
                defaultMessage="Only {percentage} of {location} properties are left for your dates."
                values={linguaValues}
            />
        );
    }
    return (
        <FormattedMessage
            id="percentBookedExplanationGenericLocationInversed"
            description="percent booked generic explanation"
            defaultMessage="Only {percentage} of properties in this location are left for your dates."
            values={linguaValues}
        />
    );
};

const callToAction = ({percentageLeft}: Props) => {
    // Show urgent message if percentageLeft <= 20
    if (percentageLeft <= 20) {
        return (
            <FormattedMessage
                id="percentBookedUrgentTitle"
                description="percent booked urgent title"
                defaultMessage="Hurry up!"
            />
        );
    }
    // Show popular message otherwise, if percentageLeft is < 60
    return (
        <FormattedMessage
            id="percentBookedPopularTitle"
            description="percent booked popular title"
            defaultMessage="Book soon!"
        />
    );
};

export function Icon() {
    return <IconButton icon="alarm-clock" />;
}

export function Content({percentageLeft, location}: Props) {
    return (
        <div className="PercentBookedSearchBannerContent">
            <span className="SearchBanner__callToAction">
                {callToAction({percentageLeft})}
            </span>
            <span className="SearchBanner__explanation">
                {searchBannerExplanation({percentageLeft, location})}
            </span>
        </div>
    );
}

export default {
    Icon,
    Content
};
